import React from "react";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import { useSelector } from "react-redux";
import CommonGrid from "../../components/CommonGrid";
import { gridColumns_MeterDetails } from "../../Utils/TableColumnDefs";
import classes from "../LoanDetails/loandetails.module.css";

const MeterDetails = () => {
  const valuesToPopulate = useSelector((state) => state.dashboard.meterDetails);
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.label
  );

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "92vh" }}
      >
        <article className="container-fluid">
          <div className="m-5 pt-5">
            <h4>Insurance Monitoring</h4>
            <CustomBreadCrumbs
              crumbs={[
                {
                  title: "Dashboard",
                  link:
                    selectedRole?.includes("Borrower")
                      ? "/borrower-dashboard-two"
                      : "/dashboard",
                },
                {
                  title: "Insurance Monitoring",
                },
              ]}
            />
          </div>
        </article>

        <article className="container-fluid p-5">
          <section className="row p-3 pt-0">
            <CommonGrid
              // className={
              //   gridColumns_MeterDetails?.length <= 10
              //     ? classes.pastDue15
              //     : gridColumns_MeterDetails?.length <= 20
              //     ? classes.pastDue25
              //     : classes.pastDue35 + `col-sm-12`
              // }
              className="col-sm-12"
              title={"Insurance Monitoring"}
              gridColumns={
                selectedRole === "Borrower"
                  ? gridColumns_MeterDetails(true)
                  : gridColumns_MeterDetails()
              }
              columnData={valuesToPopulate}
            />
          </section>
        </article>
      </section>
    </div>
  );
};

export default MeterDetails;
